import { Roles } from "../../constants/roles";

// messenger.com needs enough width to show the conversation list beside the
// thread, not just the thread — too narrow and it hides the conversation list.
const POPUP_WIDTH = 1000;
const POPUP_HEIGHT = 650;

export class FacebookMessengerLinkListener {
    public register(): void {
        // Capture phase (not bubble): several nested overlays (e.g. the Target
        // Product Search picker inside the review-create modal) call
        // stopPropagation() on inner clicks during the bubble phase, purely to
        // stop them reaching their OWN overlay's outside-click-close handler —
        // but that also silently swallowed this click before it could bubble
        // all the way up to a bubble-phase document listener here. Capture
        // phase runs top-down before any of that, so this fires regardless of
        // how deeply nested the link is.
        document.addEventListener("click", this.handleClick, true);
    }

    private readonly handleClick = (event: MouseEvent): void => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        // eslint-disable-next-line no-restricted-syntax -- document-level delegated listener (not inside a form class), matches modal-handler.ts's existing closest() usage for the same reason.
        const link = target.closest(`[data-role="${Roles.FACEBOOK_CUSTOMER_CHAT}"]`);
        if (!(link instanceof HTMLAnchorElement)) return;

        event.preventDefault();

        // A small fixed-size popup (not a full tab) triggers messenger.com's
        // own responsive compact layout, matching the Messenger "child window" feel.
        const left = Math.max(0, Math.round((window.screen.width - POPUP_WIDTH) / 2));
        const top = Math.max(0, Math.round((window.screen.height - POPUP_HEIGHT) / 2));
        const features = `popup=yes,width=${POPUP_WIDTH},height=${POPUP_HEIGHT},left=${left},top=${top},resizable=yes,scrollbars=yes`;

        window.open(link.href, "messenger-chat", features);
    };
}
